import { useNavigation } from '@react-navigation/native'
import { AppNavigation } from '../navigation/types'
import { TargetType, TimeLine } from './../generated/graphql'

export function navigateToTarget({
  target,
  navigation,
}: {
  target: { type: TargetType; id: string }
  navigation: ReturnType<typeof useNavigation<AppNavigation>>
}) {
  if (target.type === TargetType.Article)
    return navigation.navigate('Perspective', {
      articleId: target.id,
    })

  if (target.type === TargetType.Node) {
    return navigation.navigate('ClusterList', {
      nodeId: target.id,
    })
  }

  if (target.type === TargetType.Cluster) {
    return navigation.navigate('ClusterCards', {
      clusterId: target.id,
    })
  }

  if (target.type === TargetType.Contribution) {
    return navigation.navigate('PerspectiveContribution', {
      contributionId: target.id,
    })
  }
  throw new Error('target must be used with a valid targetype')
}

export function navigateToTimelinePayload({
  timeline,
  navigation,
}: {
  timeline: TimeLine
  navigation: ReturnType<typeof useNavigation<AppNavigation>>
}) {
  navigateToTarget({
    target: { type: timeline.targetType, id: timeline.targetId },
    navigation,
  })
}
